export const BASE = "BASE";
export const B_AXIS = "B_AXIS";
export const A_AXIS = "A_AXIS";
export const Y_AXIS = "Y_AXIS";
export const TOOL = "TOOL";
export const DENTAL_FIXTURE = "DENTAL_FIXTURE";
